import Vue from "vue";
import App from "./App.vue";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import router from "./router";
import VueRouterUserRoles from "vue-router-user-roles";
import store from "./store";
import vx_api from "./vuemix";
import LoadScript from "vue-plugin-load-script";
import VueCookies from "vue-cookies";
import SlideOut from "@hyjiacan/vue-slideout";
import VueRouterBackButton from "vue-router-back-button";

import UploadAWorker from "worker-loader!./upload.worker.js"
import UploadVWorker from "worker-loader!./uploadv.worker.js"
import EncodeWorker from "worker-loader!./encode.worker.js"
import DecodeWorker from "worker-loader!./decode.worker.js"
import MediaDevices from "./mediadevices.js"
import getAWS from "./AWS.js";

window.new_jsDecWorker = function() {
  return new DecodeWorker;
}

Vue.config.productionTip = false;
Vue.use(VueRouterUserRoles, {
  router
});
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(LoadScript);
Vue.use(VueCookies);
Vue.use(SlideOut);
Vue.use(VueRouterBackButton, { router });

var __vue;
function check_if_signedin(appkind) {
  let qstring = window.location.href.split("#")[1].split("/");
  let loggedInFrom = qstring[2] || "vuemix";
  let isGuest = false;
  
  // GET self
  let cred_me = getLocal("vx_cred_me");
  let post_msgs = getLocal("init-msgs",true);
  eraseLocal("init-msgs");
  vx_api
    .getSelf(window.vx, cred_me)
    .then(self_res => {
      self_res.loggedInFrom = loggedInFrom;
      Vue.prototype.$user.set(
        Object.assign({role: "authenticatedUser"},
        self_res)
      );
    })
    .catch(e => {
      eraseLocal("vx_cred_me");
      Vue.prototype.$user.set({role: "guest"});
      isGuest = true;
    })
      .finally(() => {
        let vue = __vue = new Vue({
          router,
          store,
          render: h => h(App)
        }).$mount("#app");
        /* Attempt here in case state known prior to
           authentication check */
        __vue.$children[0].showTrackMessage();
        let dev = store.get("mydevice");
        dev.list_win(function(r) {
          let me;
          let pt;
          let pthref = vue.$router.resolve({name: "room"}).href;
          r.wins.forEach(function(w) {
            if (w.url == window.location.href) { me = w; }
            if (w.url.endsWith(pthref)) { pt = w; }
          });
          if (!pt || !me || me.id == pt.id) { return; }
          let p = {id:pt.id, pos:[Math.max(0,pt.pos[0]), Math.max(0,pt.pos[1]),
                                  Math.min(r.w,pt.pos[2]),
                                  Math.min(r.h,pt.pos[3])]};
          if (vue.$router.currentRoute.name == "chat") {
            let m = {id:me.id, pos:[0, p.pos[1], 0.2*r.w, p.pos[3]]};
            let opt = {can_slide:true, can_shrink:true};
            comp_win_pos(r.w, r.h, m.pos, p.pos, "to_right", opt);
            dev.move_win([ m, p ]);
          } else if (vue.$router.currentRoute.name == "share") {
            let m = {id:me.id, pos:[0, p.pos[1],
                                    0.4*r.w, Math.min(0.5*r.h,p.pos[3])]};
            let opt = {can_slide:false, can_shrink:true};
            comp_win_pos(r.w, r.h, m.pos, p.pos, "to_left", opt);
            dev.move_win([ m, p ]);
          }
        });
        
        /* vx.room.auto_raise -- external
         * vx.room.auto_join  -- external
         * vx.auto_open_panel -- internal to room.js
         * vx.guestQuestion   -- external
         * vx.postAuthAction  -- external
         */
        if (post_msgs) {
          vx.postAuthAction = post_msgs[0];
        }

        /* Needed for oauth sign-in and app remote launch */
        if (!isGuest) {
          continue_to_page(vue.$router);
        }
      });
}

function computeConcurrency(result_cb) {
      // create worker concurrency estimation code as blob
      var blobUrl = URL.createObjectURL(new Blob(['(',
        function() {
          self.addEventListener('message', function(e) {
            // run worker for 4 ms
            var st = Date.now();
            var et = st + 4;
            while(Date.now() < et);
            self.postMessage({st: st, et: et});
          });
        }.toString(),
      ')()'], {type: 'application/javascript'}));

      function sample(max, samples, numWorkers, callback) {
        if(samples === 0) {
          // get overlap average
          var avg = Math.floor(max.reduce(function(avg, x) {
            return avg + x;
          }, 0) / max.length);
          avg = Math.max(1, avg);
          //console.log("max",JSON.stringify(max),avg);
          return callback(null, avg);
        }
        map(numWorkers, function(err, results) {
          max.push(reduce(numWorkers, results));
          setTimeout(function() {
            sample(max, samples - 1, numWorkers, callback);
          }, 250);
        });
      }

      function map(numWorkers, callback) {
       var workers = [];
       var results = [];
       for(var i = 0; i < numWorkers; ++i) {
         var worker = new Worker(blobUrl);
         worker.addEventListener('message', function(e) {
           results.push(e.data);
           if(results.length === numWorkers) {
             for(var i = 0; i < numWorkers; ++i) {
               workers[i].terminate();
             }
             callback(null, results);
           }
        });
        workers.push(worker);
       }
       for(var i = 0; i < numWorkers; ++i) {
         workers[i].postMessage(i);
       }
      }

      function reduce(numWorkers, results) {
        // find overlapping time windows
        var overlaps = [];
        for(var n = 0; n < numWorkers; ++n) {
          var r1 = results[n];
          var overlap = overlaps[n] = [];
          for(var i = 0; i < numWorkers; ++i) {
            if(n === i) {
              continue;
            }
            var r2 = results[i];
            if((r1.st >= r2.st && r1.st < r2.et) ||
               (r2.st >= r1.st && r2.st < r1.et)) {
              overlap.push(i);
            }
          }
        }
        // get maximum overlaps
        return overlaps.reduce(function(max, overlap) {
          return Math.max(max, overlap.length);
        }, 0);
      }

  let j = getLocal("_hw",true);
  if (!j || !j.threads) {
    // take 10 samples using 16 workers
    sample([], 10, 16, function(err, cores) {
      setLocal("_hw",JSON.stringify({threads: cores}));
      result_cb(cores);
    });
  } else {
    result_cb(j.threads);
  }
};

function check_if_iframe(x) {
  let vue = this;
  try {
    if (window.self !== window.top) {
      x.in_iframe = true;
      x.src_iframe = window.frameElement;
      return true;
    }
  } catch (e) {
    x.in_iframe = true;
    return true;
  }
  x.in_iframe = false;
  return false;
}

function check_if_cors_iframe(x) {
  try {
    x.in_cors_iframe = (!window.top.location.hostname);
  } catch (e) {
    x.in_cors_iframe = true;
  }
}

if (true) {
  let AWS = getAWS();
  let awsTranscriber = new AWS.Transcriber();
  let mydevice = {};
  let nav_ua = window.navigator.userAgent;
  let nav_vn = window.navigator.vendor;
  let nav_pl = window.navigator.platform;
  window.vx.about.is_opera = (/OPR|Opera/.test(nav_ua));
  window.vx.about.is_edge = (/Edg\//.test(nav_ua));
  window.vx.about.is_firefox = (/Firefox\//.test(nav_ua));
  window.vx.about.is_chrome = (/Chrom/.test(nav_ua) && nav_vn == "Google Inc." && !window.vx.about.is_opera);
  window.vx.about.is_safari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  window.vx_get_mydevice = function() {
    return mydevice;
  };

  mydevice.start_preview = function() { };
  mydevice.stop_capture = function() { };
  mydevice.stop_render = function() { };
  mydevice.stop_share = function() { };
  mydevice.query_audio_activity = function() { };
  mydevice.set_defaults = function() { };
  mydevice.flip_camera = function() { };
  mydevice.list_win = function() { };
  mydevice.move_win = function() { };
  mydevice.focus_all_win = function() { };
  mydevice.set_audio_ns = function() { };
  mydevice.set_audio_at = function() { };
  mydevice.bgef = {};
  mydevice.kvm_supported = false;
  mydevice.preview_video_group = null;
  mydevice.preview_video_source = null;
  mydevice.open_native_url = function(url) { window.open(url,"_blank"); }
  check_if_iframe(mydevice);
  check_if_cors_iframe(mydevice);

  if (!mydevice.in_iframe) {
    mydevice.multi_window = true;
  } else {
    mydevice.multi_window = false;
  }
  // Screen Share
  mydevice.do_jackunplug = false;
  mydevice.otf_src_change = false;
  mydevice.release_on_hide = false;
  mydevice.has_open_dup = false;
  mydevice.has_audio_ns = false;
  mydevice.pt_can_play = 0;
  mydevice.pt_can_send = false;
  mydevice.has_audio_selection = false;
  mydevice.enable_debug_graph = true;  
  window.gbl_session_callback = function(args) { };
  window.stop_localloopback = function() {};

  if (window.webkit && window.webkit.messageHandlers &&
      window.webkit.messageHandlers.vxcapbr) {
    /* DEVICE: iOS Bridge */
    mydevice.can_useWPlay = true;
    if (window.am_in_iframe()) {
      window.capbrPost = function() { }
    } else {
      /* Playback MediaSource Bridge */
      VuemixSDK.NMSBridge && VuemixSDK.NMSBridge.post("reset", {});
      /* Capture Bridge */
      window.vxcapbr = window.webkit.messageHandlers.vxcapbr;
      window.capbrPost = function(type, msg) {
        msg.typ = type;
        window.vxcapbr.postMessage(msg);
      }
    }
    if (!window.webkit.messageHandlers.vxnbr) {
      /* OLD pre-dl_bridge iOS APP */
      window.location.href = "/mm2/";
    }

    window.gbl_session_callback = function(args) {
      if (vx && vx.debug) { console.log("gbl_session_callback"+JSON.stringify(args)); }
      if (window.vx.about) { window.vx.about.gc++; }
      if (!args) { return; }

      let ev = args.ev;
      if (ev == "state") {
        let mydevice = store.get("mydevice");
        //console.log("mydevice:"+JSON.stringify(mydevice));
        window.vx.localloopback = window.vx.localloopback || {};
        if (args.session != 0) {
          mydevice.capture_state = "capturing";
          window.vx.localloopback.active = true;
        } else {
          if (window.vx.localloopback.active) {
            window.vx.localloopback.active = false;
          }
          window.reject_1on1 && window.reject_1on1();
          mydevice.capture_state = "off";
        }
      } else if (ev == "info") {
        if (window.vx.about) {
          window.setAppVersion("2.0.16", args.client_ver);
          window.vx.about.os_version = args.os_ver;
          window.vx.about.app_uuid = args.app_config["CLIENT_UUID"];
        }
        if (!mydevice.tracking_setting) {
          if (!args.auth_track) {
            mydevice.tracking_setting = "none";
          } else {
            mydevice.tracking_setting = "enabled";
          }
          if (__vue) {
            /* Try here in case state known after
               authentication check */
            __vue.$children[0].showTrackMessage();
          }
        }
        //if (!geAppVersion(args.client_ver, "2.0.22") ||
        //    !geAppVersion(args.os_ver, "14.0.0")) {
        //  /* Only 2.0.22+ and iOS 14+ supported */
        //  mydevice.can_useWPlay = false;
        //  window.vx.about.os_version += "-no";
        //}
        if (args.system_info) {
          window.vx.sysinfo = {};
          window.vx.sysinfo.apple = args.system_info.replace(/\,/g,".")
          window.vx.about.level = 0;
          if (/iPhone[789]\./.test(window.vx.sysinfo.apple)) {
            window.vx.about.level = 1;
          }
        }
        if (args.deep_link) {
          let opt = {};
          opt.delay = 1250;
          if (window.set_post_login_url(args.deep_link,
                                        args.deep_link_ep, opt)) {
            /* Ok to try to use deep_link */
            if (__vue &&
                __vue.$children[0].currentUser.role === "authenticatedUser") {
              continue_to_page(__vue.$router);
            }
          }
        } // deep_link
      } else if (ev == "device_info") {
      } else if (ev == "error") {
        let desc = args.desc;
        window.capbrPost("stop", {});
      }
    };

    window.stop_localloopback = function() {
      let opt = {};
      opt.l = 0;
      opt.r = 0;
      opt.t = 0;
      opt.b = 0;
      window.capbrPost("set_preview_pos", opt);
    }

    window.start_localloopback = function($el) {
      window.setTimeout(function() {
        let trect = $el[0].getBoundingClientRect();
        let wrect = $(".vxwplayerview")[0].getBoundingClientRect();
        let opt = {};
        opt.l = (trect.left - wrect.left);
        opt.r = (trect.width + opt.l);
        opt.t = (trect.top - wrect.top);
        opt.b = (trect.height + opt.t);
        opt.h = "first";
        window.capbrPost("set_preview_pos", opt);
      }, 1);
    };
    
    mydevice.set_defaults = function(opt) {
    };
    
    mydevice.get_av_groups = function(opt, cb) {
      let groups = {video:[],audio:[]};
      groups.video.push("Cameras");
      //groups.video.push("-none-");
      cb(groups);
    };
    mydevice.get_av_sources = function(kind,name,cb) {
      if (name == "Cameras") {
        cb([{i:1,n:"Front Camera"},{i:2,n:"Back Camera"}]);
      } else {
        cb([{i:0,n:"-none-"}]);
      }
    };
    
    mydevice.start_capture = function(opt) {
      let back = false;
      let none = false;
      let vpbypass = 0;
      let cmds = opt.cmds.slice();

      switch(opt.sel_video) {
      case 1:
        mydevice.vt = {sm:true, pt:true};
        break;
      case 2:
        back = true;
        mydevice.vt = {sm:true, pt:true};
        break;
      default:
        none = true;
        mydevice.vt = {};
        break;
      }

      if (opt.skipth) {
        cmds.push("gop_skip_threshold="+opt.skipth);
      } else {
        cmds.push("gop_skip_threshold=0.4");
      }
      if (opt.upload && opt.upload.curl) {
        opt.upload.sockopts = opt.upload.curl;
      }
      if (opt.vpbypass) {
        vpbypass = 1;
      }
      //console.log("Setting opt:"+JSON.stringify(opt));
      //opt.cmds.push("aenc_reset_interval=120");
      // Keep > gop_skip_threshold
      //opt.cmds.push("venc_queue_size=0.7");
      window.capbrPost("start", {
        cmds: cmds,
        fmt: opt.fmt,
        upload: opt.upload,
        //preview : { "width":640, "height":360, fps:4 },
        video: {
          back: back,
          none: none,
          vpBypass: vpbypass,
          cam_fps: 18,
          cam_width: 768,
          cam_height: 432,
          srate: 44100,
          stbl: "off",
          scaler: "sws",
          scalerAlgo: opt.is_pres ? "FAST_BILINEAR" : "BICUBIC",
          threads: 2,
          me: "hex",
          merange: 16,
          subme: 4
        },
        cb: "gbl_session_callback($ARGS)"
      });
    };

    mydevice.stop_capture = function(opt,cb) {
      delete mydevice.vt;
      window.capbrPost("stop", {});
      if (cb) { cb(null,{}); }
    };

    mydevice.start_preview = function(opt,cb) {
      if (cb) { cb(null,{}); }
    };

    mydevice.flip_camera = function(opt,cb) {
      capbrPost("swcam", {});
    };

    mydevice.set_idle_timer = function(opt,cb) {
      // on == false prevents sleep
      capbrPost("set_idle_timer", {on:opt.on});
    };

    mydevice.tupload_restart = function(av) {
      capbrPost("restart_upload", {"type":av});
    };

    mydevice.tupload_stall = function(av,dur) {
      capbrPost("stall_upload", {"type":av, "dur" : dur});
    };

    mydevice.open_native_url = function(url, in_webview=true) {
      let opt = { url : url };
      if (in_webview) {
        opt.back_url = window.location.href;
      }
      window.capbrPost("open_url", opt);
    };

    mydevice.swap_speaker_src = function(opt) {
      mydevice.speaker_src = !mydevice.speaker_src;
      if (mydevice.speaker_src) {
        /* Speaker + Bluetooth enabled */
        //console.log("Speaker4");
        window.capbrPost("speaker",{
          custom: {
            mode : "AVAudioSessionModeVideoChat",
            options: 4,
          }
        });
      } else {
        /* Earbud + Bluetooth enabled */
        //console.log("Earbud4");
        window.capbrPost("speaker",{
          custom: {
            mode : "AVAudioSessionModeVoiceChat",
            options: 4,
          }
        });
      }
    };
    mydevice.init_speaker_src = function(opt) {
      /* Speaker with bluetooth disabled */
      //console.log("Speaker0");
      mydevice.speaker_src = true;
      window.capbrPost("speaker",{
        custom: {
          mode : "AVAudioSessionModeVideoChat",
          options: 0,
        }
      });
      window.setTimeout(function() {
        console.log("Play");
        let audioCtx = VuemixSDK.getAudioCtx();
        let src = audioCtx.createBufferSource();
        src.connect(audioCtx.destination);
        src.start();
        window.setTimeout(function() {
          console.log("Done");
          /* Speaker with bluetooth enabled -- true */
          // /* Earbud + Bluetooth enabled -- false */
          mydevice.speaker_src = true;
          window.capbrPost("speaker",{
            custom: {
              mode : "AVAudioSessionModeVoiceChat",
              //mode : "AVAudioSessionModeVideoChat",
              options: 4,
            }
          });
        }, 200);
      }, 300);
    };

    mydevice.get_audio_gain = function() {
      if (mydevice.speaker_src) {
        return mydevice.audio_gain1;
      }
      return mydevice.audio_gain2;
    }
    mydevice.set_audio_gain = function(g) {
      if (mydevice.speaker_src) {
        mydevice.audio_gain1 = g;
        return;
      }
      mydevice.audio_gain2 = g;
    }

    if (VuemixSDK.NMSBridge) {
      VuemixSDK.NMSBridge.post("bgcolor", { r: 0x1a, g: 0x1a, b: 0x1d, a: 1 });
      $(document).on("scroll", e => {
        VuemixSDK.NMSBridge && VuemixSDK.NMSBridge.moveAll();
      });
    }
    mydevice.bridge_kind = "ios";
    mydevice.audio_gain1 = 25;
    mydevice.audio_gain2 = 2;
    mydevice.set_background = false;
    mydevice.capture_state = "unknown";
    mydevice.can_capture = true;
    mydevice.has_bridge = true;
    mydevice.has_preview = false;
    mydevice.do_jackunplug = true;
    mydevice.can_flip = true;
    mydevice.show_refresh = false;
    mydevice.always_has_lg = true;
    mydevice.pt_can_play = 4;
    window.vx.localloopback = {active:false};
    window.vx.about.app_kind = "ios";
    mydevice.is_app = true;
    window.vx.about.is_app = true;
    window.capbrPost("attach", { cb: "gbl_session_callback($ARGS)" });
    mydevice.init_speaker_src();
    mydevice.set_idle_timer({on:false});
    mydevice.ss_local = true;
    mydevice.multi_window = false;

  } else if (/*false && */window.cefQuery) {
    /* DEVICE: CEF capture bridge */
    mydevice.can_useWPlay = true;
    mydevice.bridge_kind = "cef";
    mydevice.audio_gain = 1;
    if (/(Mac)/i.test(navigator.platform)) {
      mydevice.audio_gain = 4;
    }
    mydevice.set_background = true;
    mydevice.can_capture = true;
    mydevice.capture_state = "off";
    mydevice.otf_src_change = true;
    mydevice.release_on_hide = true;
    mydevice.has_bridge = true;
    mydevice.has_preview = true;
    mydevice.can_flip = false;
    mydevice.show_refresh = false;
    mydevice.always_has_lg = true;
    mydevice.pt_can_play = 4;
    mydevice.pt_can_send = false;
    window.vx.localloopback = {active:false};
    window.vx.about.unmute = true;
    window.vx.about.app_kind = "chrome";
    mydevice.is_app = true;
    mydevice.has_huge = true;
    mydevice.has_audio_selection = true;
    window.vx.about.is_app = true;
    mydevice.get_av_groups = function(opt, cb) {
      let request = {
        "req_id": "get_sources"
      };
      //cb({video:["-none-","a","b"],audio:["c","d"]}); return; //FORTEST
      window.cefQuery({
        request: JSON.stringify(request),
        onSuccess: function (rsp) {
          let groups = {video:[],audio:[]};
          let j = JSON.parse(rsp);
          j.video.forEach(function(g) {
            if (opt.filter == "true") {
              if (!g.match(/video|display/i)) {
                return;
              }
            }
            groups.video.push(g);
          });
          //groups.video.push("-none-");
          j.audio.forEach(function(g) {
            if (opt.filter == "true") {
              if (!g.match(/audio/i)) {
                return;
              }
              //if (g.match(/audio output/i)) {
              //  return;
              //}
            }
            groups.audio.push(g);
          });
          cb(groups);
        }, onFailure: function (err, msg) {
          cb({});
        }
      });      
    };
    mydevice.get_av_sources = function(a,v,cb) {
      let request = {
        "req_id": "init_sources"
      };
      if (a) {
        request.audio = a;
      }
      if (v) {
        request.video = v;
      }
      /* if (v == "-none-" || a == "-none-") { //FORTEST
        cb({video:[],audio:[]});
      } else if (a == "c" || v == "a") {
        cb({video:[{i:0,n:"cam"},{i:1,n:"bluff"}],audio:[{i:0,n:"mic"},{i:1,n:"grape"}]});
      } else {
        cb({video:[{i:2,n:"noodle"},{i:4,n:"asd"}],audio:[{i:0,n:"wrapper"},{i:1,n:"pqoi"}]});
      }
      return; */
      window.cefQuery({
        request: JSON.stringify(request),
        onSuccess: function (rsp) {
          let srcs = {};
          let j = JSON.parse(rsp);

          if (j.video) {
            srcs.video = [];
            j.video.forEach(function(name, idx) {
              srcs.video.push({i:idx, n:name});
            });
          }
          if (j.audio) {
            srcs.audio = [];
            j.audio.forEach(function(name, idx) {
              srcs.audio.push({i:idx, n:name});
            });
          }
          cb(srcs);
        }, onFailure: function (err, msg) {
          cb({});
        }
      });
    };

    /* Background status heartbeat */
    window.gbl_session_callback = function(args) {
      //console.log("hb:"+JSON.stringify(args));
      if (window.vx.about) { window.vx.about.gc++; }
      if (args) {
        let ev = args.ev;
        if (ev == "state") {
          let mydevice = store.get("mydevice");
          if (args.session != 0) {
            mydevice.capture_state = "capturing";
            window.vx.localloopback = window.vx.localloopback || {};
            window.vx.localloopback.active = true;
          } else {
            mydevice.capture_state = "off";
          }
          if (args.screencap != 0) {
            mydevice.share_state = "sharing";
          } else {
            if (mydevice.share_state != "off") {
              window.api_clear_sshare(window.vx, {ss:"-"}, function(){});
              if (window.vx.user) {
                window.vx.user.ss = "-";
              }
            }
            if (window.vx && window.vx.user &&
                window.vx.user.ss && window.vx.user.ss != "-") {
              /* Left over from user canceling share selection */
              window.vx.user.ss = "-";
              window.api_clear_sshare(window.vx, {ss:"-"}, function(){});
            }
            mydevice.share_state = "off";
          }
        } else if (ev == "error") {
          if (args.result == "cap_stopped") {
            console.log("capture error: ",args.desc);
            //mydevice.stop_capture
            window.vx.localloopback = window.vx.localloopback || {};
            window.vx.localloopback.active = false;
            mydevice.capture_state = "off";
            mydevice.preview_video_group = null;
            mydevice.preview_video_source = null;
            delete mydevice.vt;
            window.vx_pvw_cancel();
            window.reject_1on1 && window.reject_1on1();
          }
        } else if (ev == "set_deep_link") {
          if (args.deep_link && args.deep_link_ep){
            mydevice.focus_all_win();
            if (window.set_post_login_url(args.deep_link, args.deep_link_ep)) {
              /* Ok to try to use deep_link */
              if (__vue &&
                  __vue.$children[0].currentUser.role === "authenticatedUser") {
                continue_to_page(__vue.$router);
              }
            }
          } // deep_link
        }
      }
    };
    
    window.start_localloopback = function($el) {
      $el.append('<canvas id="pvw_self" style="width:100%;height:100%;"></canvas>');
      window.vx_pvw_img("#pvw_self", 640, 360, {delay: 100});
    };

    mydevice.set_defaults = function(opt) {
      window.cefQuery({
        request: JSON.stringify({"req_id":"update_app_config",
                                 "cfg" : opt.cfg}),
        onSuccess: function (rsp) {
          if (opt.need_restart) {
            /* Must restart for values to take effect */
            window.do_issue_restart =
              "Default settings have been updated. Please relaunch the app.";
            if (window.issue_restart) {
              window.issue_restart(window.do_issue_restart);
            }
          }
        }, onFailure: function (err, msg) {
          // eslint-disable-next-line
          console.log("CEF update_app_config failed");
        }
      });
    };

    window.cefQuery({
      request: JSON.stringify({"req_id":"attach",
                               "cb" : "gbl_session_callback($ARGS)"}),
      onSuccess: function (rsp) {
        let j = window.to_json(rsp);
        if (!j) { return; }
        
        if ((""+j.app_config["FPS"]) != (""+vx.fps)) {
          mydevice.set_defaults({need_restart:true, cfg:{"FPS":(""+vx.fps)}});
        }
        if (j.app_config["START_URL"] && window.vx.about) {
          window.vx.about.start_url = j.app_config["START_URL"];
        }
        if (j.app_config["CLIENT_UUID"] && window.vx.about) {
          window.vx.about.app_uuid = j.app_config["CLIENT_UUID"];
        }
        if (j.deep_link) {
          window.set_post_login_url(j.deep_link, j.deep_link_ep);
        }
        if (j.client_ver && window.vx.about) {
          window.setAppVersion("2.0.44", j.client_ver);
          if (geAppVersion(j.client_ver, "2.0.40")) {
            mydevice.kvm_supported = true;
          }
          if (geAppVersion(j.client_ver, "2.0.42")) {
            mydevice.has_open_dup = true;
          }
          if (geAppVersion(j.client_ver, "2.0.43")) {
            mydevice.has_audio_ns = true;
          }
        }
        if (j.os_ver && window.vx.about) {
          window.vx.about.os_version = j.os_ver.replace(/\,/g,".");
        }
        let sys = window.parse_system_info(j.system_info);
        window.vx.sysinfo = sys;
        window.vx.about.level = 1;
        if (!sys.windows) {
          if (sys.cpu >= 4000 || sys.cores >= 4) {
            window.vx.about.level = 0;
          }
        } else {
          if (sys.intel && (sys.cpu >= 6000 || sys.cores >= 4)) {
            window.vx.about.level = 0;
          } else if (sys.amd && (sys.cpu == "ryzen" || sys.cpu == "fx")) {
            window.vx.about.level = 0;
          }
        }
      }, onFailure: function (err, msg) {
        // eslint-disable-next-line
        console.log("CEF heartbeat attach failed");
      }
    });

    mydevice.start_capture = function(opt) {
      let cmds = opt.cmds.slice();
      let ns;
      cmds.push("gop_skip_threshold=0.1");
      cmds.push("aenc_reset_interval=120");
      // Keep > gop_skip_threshold
      cmds.push("venc_queue_size=0.7");
      if (opt.nsdb) { ns = true; }
      let request =
          { req_id: "start_capture",
            //sel_video: opt.sel_video,
            sel_audio: opt.sel_audio,
            cmds: cmds,
            fmt: opt.fmt,
            upload: opt.upload,
            preview : { "width":640, "height":360 },
            video: {
              scalerAlgo: opt.is_pres ? "FAST_BILINEAR" : "BICUBIC",
              ns: ns,
              threads: 2,
              me: "hex",
              merange: 16,
              subme: 4,
              bskip: (0|opt.bskipon),
              aac_coder:"fast",
            }
          };
      mydevice.vt = mydevice.vt || {};
      console.log("CAPTURE:",JSON.stringify(mydevice.vt),
                  JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (response) {
          mydevice.capture_state = "capturing";
          /* via "preview" above */
          window.vx.localloopback = window.vx.localloopback || {};
          window.vx.localloopback.active = true;
          if (ns) {
            mydevice.set_audio_ns({level: opt.nsdb});
          }
        }, onFailure: function (err, msg) {
          mydevice.capture_state = "off";
          // eslint-disable-next-line
          console.log("Error");
        }
      });
    };

    mydevice.stop_capture = function(opt,cb) {
      let request = {
        "req_id": "stop_capture"
      };
      window.vx.localloopback = window.vx.localloopback || {};
      window.vx.localloopback.active = false;
      window.reject_1on1 && window.reject_1on1();
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (response) {
          mydevice.capture_state = "off";
          mydevice.preview_video_group = null;
          mydevice.preview_video_source = null;
          delete mydevice.vt;
          window.vx_pvw_cancel();
          if (cb) { cb(null,{}); }
        }, onFailure: function (err, msg) {
          console.log("stop_capture: error:"+msg);
          if (cb) { cb({error: msg}); }
        }
      });
    };

    mydevice.set_audio_ns = function(opt) {
      let level = 0 | opt.level;
      let request = {
        "req_id": "set_audio_ns",
        "level" : level,
      };
      if (mydevice.capture_state == "off") {
        /* Has no effect unless capturing */
        return;
      }
      //console.log(JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
        }
      });
    };

    mydevice.stop_render = function(opt,cb) {
      if (mydevice.capture_state != "off")   {
        return;
      }
      // eslint-disable-next-line
      console.log("stopping render");
      delete mydevice.vt;
      mydevice.preview_video_group = null;
      mydevice.preview_video_source = null;
      mydevice.get_av_sources(null, "-none-", function(srcs) {
      });
    };

    mydevice.start_preview = function(opt,cb) {
      let request =
          { req_id: "start_render",
            sel_video: opt.video,
            //sel_audio: opt.audio,
            preview : { "width":640, "height":360 },
          };
      // eslint-disable-next-line
      console.log("PREVIEW:"+JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (response) {
          mydevice.vt = {sm:true, lg:true};
          if (cb) { cb(null,{}); }
        }, onFailure: function (err, msg) {
          if (cb) { cb({error: msg}); }
        }
      });
    };

    mydevice.set_video_rc = function(opt,cb) {
      // Must match 't' order of scfg in start_capture
      // [{"t"=>"t656x368s", "crf"=>25, "maxrate"=>550, "bufsize"=>800, maxcrf=>30},]
      let streams = [];
      opt.forEach(function(s) {
        let rc = {};
        if (s.t == "a44100") { return; }
        if (s.crf) { rc.crf = 0|s.crf; }
        if (s.maxrate) { rc.maxrate = 0|s.maxrate; }
        if (s.bufsize) { rc.bufsize = 0|s.bufsize; }
        if (s.maxcrf) { rc.maxcrf = 0|s.maxcrf; }
        streams.push(rc);
      });
      let request =
          { req_id: "set_video_rc",
            streams: streams,
          };
      // eslint-disable-next-line
      console.log("SET VIDEO RC:"+JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (response) {
          if (cb) { cb(null,{}); }
        }, onFailure: function (err, msg) {
          if (cb) { cb({error: msg}); }
        }
      });
    };

    mydevice.share_state = "off";
    mydevice.start_share = function(opt,cb) {
      //cb(null,"ok"); return; //FORTEST
      let request =
          { req_id: "start_screen_capture",
            cmds: opt.cmds,
            fmt: opt.fmt,
            upload: opt.upload,
            cap: opt.cap,
          };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          cb(null,"ok");
        }, onFailure: function (err, msg) {
          window.api_clear_sshare(window.vx, {ss:"-"}, function(){});
          if (window.vx.user) {
            window.vx.user.ss = "-";
          }
          cb(err+":"+msg);
        }
      });
    };
    mydevice.stop_share = function(opt={},cb) {
      //cb(null,"ok"); return; //FORTEST
      let request = {
        "req_id": "stop_screen_capture"
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          mydevice.annotate_url = null;
          if (window.vx.user) { window.vx.user.ss = "-"; }
          if (opt.logout) {
            /* Don't issue APIs on logout */
            mydevice.share_state = "off";
          } else {
            window.update_user_assets && window.update_user_assets();
            window.api_clear_sshare(window.vx, {ss:"-"}, function() {
                mydevice.share_state = "off";
            });
          }
          if (cb) { cb(null,"ok"); }
        }, onFailure: function (err, msg) {
          if (cb) { cb(err); }
        }
      });
    };
    mydevice.open_annotator = function(opt, cb) {
      let request = {
        "req_id": "start_annotator",
        upload : { vxshare: opt.url }, 
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          if (cb) { cb(null,"ok"); }
        }, onFailure: function (err, msg) {
          if (cb) { cb(err); }
        }
      });
    };
    mydevice.close_annotator = function(opt, cb) {
      let request = {
        "req_id": "stop_annotator",
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
        }
      });
    };
    mydevice.annotate_url = null;
   
    mydevice.query_audio_activity = function(cb) {
      let request = {
        "req_id": "get_audio_activity"
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          let j = window.to_json(rsp);
          if (cb) { cb((j.max_volume & 0x7f)); }
        }, onFailure: function (err, msg) {
        }
      });      
    };
    
    mydevice.open_native_url = function(url) {
      let request = {
        "req_id": "open_url",
        "url": url,
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
        }
      });
    };

    mydevice.tupload_restart = function(av) {
      let request = {
        "req_id": "restart_upload",
        "type":av,
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
        }
      });
    };

    mydevice.tupload_stall = function(av,dur) {
      let request = {
        "req_id": "stall_upload",
        "type":av,
        "dur":dur,
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
        }
      });
    };

    mydevice.kvm_start_server = function(kid, cb) {
      let request = {
        "req_id": "start_vncserver",
        "id": ""+kid,
      };
      //console.log(JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          cb && cb();
        }, onFailure: function (err, msg) {
          console.log("start_vncserver: error:"+msg);
          cb && cb(true);
        }
      });
    };
    mydevice.kvm_stop_server = function(kid, cb) {
      let request = {
        "req_id": "stop_vncserver",
        "id": ""+kid,
      };
      //console.log(JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          cb && cb();
        }, onFailure: function (err, msg) {
          console.log("stop_vncserver: error:"+msg);
          cb && cb(true);
        }
      });
    };
    mydevice.kvm_start_client = function(kid, cb) {
      let request = {
        "req_id": "start_vncclient",
        "id": ""+kid,
      };
      //console.log(JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          cb && cb();
        }, onFailure: function (err, msg) {
          console.log("start_vncclient: error:"+msg);
          cb && cb(true);
        }
      });
    };
    mydevice.kvm_stop_client = function(kid, cb) {
      let request = {
        "req_id": "stop_vncclient",
        "id": ""+kid,
      };
      //console.log(JSON.stringify(request));
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          cb && cb();
        }, onFailure: function (err, msg) {
          console.log("stop_vncclient: error:"+msg);
          cb && cb(true);
        }
      });
    };

    mydevice.list_win = function(cb,re) {
      let request = {
        "req_id": "get_windows",
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
          console.log(rsp);
          let j = window.to_json(rsp);
          let r = {wins:[]};
          r.w = j.scr_w;
          r.h = j.scr_h;
          j && j.windows && j.windows.forEach(function(w) {
            if (!re || re.match(w.url)) {
              r.wins.push(w);
            }
          });
          cb && cb(r);
        }, onFailure: function (err, msg) {
          console.log("get_windows: error:"+msg);
          cb && cb({winds:[]});
        }
      });
    }

    mydevice.move_win = function(list) {
      let steps = [];
      list.forEach(function(w) {
        let s = {};
        s.target = "id:"+w.id;
        s.pos = w.pos.join(":");
        s.action = "set_pos";
        steps.push(s);
      });
      let request = {
        "req_id": "arrange_windows",
        "steps": steps,
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
          console.log("move_win: error:"+msg);
        }
      });
    }

    mydevice.focus_all_win = function() {
      let request = {
        "req_id": "arrange_windows",
        "steps": [{target:".*",action:"focus",global:true}],
      };
      window.cefQuery({
        request:JSON.stringify(request),
        onSuccess: function (rsp) {
        }, onFailure: function (err, msg) {
          console.log("focus_all_win: error:"+msg);
        }
      });
    }

    mydevice.get_audio_gain = function() {
      return mydevice.audio_gain;
    }
    mydevice.set_audio_gain = function(g) {
      mydevice.audio_gain = g;
    }

  } else if (window.android_vxcapbr) {
    /* DEVICE: Android Bridge */
    mydevice.can_useWPlay = true;
    if (window.am_in_iframe()) {
      window.capbrPost = function() { }
    } else {
      /* Playback MediaSource Bridge */
      VuemixSDK.NMSBridge && VuemixSDK.NMSBridge.post("reset", {});
      /* Capture Bridge */
      window.vxcapbr = {
        postMessage(msg) {
          window.android_vxcapbr.postJSONMessage(JSON.stringify(msg));
        }
      };
      window.capbrPost = function(type, msg) {
        msg.typ = type;
        window.vxcapbr.postMessage(msg);
      };
    }

    window.gbl_session_callback = function(args) {
      //console.log("gbl_session_callback"+JSON.stringify(args));
      if (window.vx.about) { window.vx.about.gc++; }
      if (!args) { return; }

      let ev = args.ev;
      if (ev == "state") {
        let mydevice = store.get("mydevice");
        //console.log("mydevice:"+JSON.stringify(mydevice));
        window.vx.localloopback = window.vx.localloopback || {};
        if (args.session != 0) {
          mydevice.capture_state = "capturing";
          window.vx.localloopback.active = true;
        } else {
          if (window.vx.localloopback.active) {
            window.vx.localloopback.active = false;
            window.vx_stop_pingpong("loopback");
          }
          mydevice.capture_state = "off";
          window.reject_1on1 && window.reject_1on1();
        }
      } else if (ev == "info") {
        if (window.vx.about) {
          window.setAppVersion("2.0.15", args.client_ver);
          window.vx.about.os_version = args.os_ver;
          window.vx.about.app_uuid = args.app_config["CLIENT_UUID"];
        }
        if (args.system_info) {
          window.vx.sysinfo = {};
          window.vx.sysinfo.android = args.system_info.replace(/\,/g,".")
          window.vx.about.level = 0;
          //if (/iPhone[789]\./.test(window.vx.sysinfo.apple)) {
          //    window.vx.about.level = 1;
          //  }
        }
        if (args.deep_link) {
          window.set_post_login_url(args.deep_link, args.deep_link_ep);
        }
      } else if (ev == "device_info") {
      } else if (ev == "error") {
        let desc = args.desc;
        window.capbrPost("stop", {});
        }        
    };

    window.start_localloopback = function($el) {
      $el.append('<div id="pvw_self" style="width:100%;height:100%;"></div>');
      window.vx_start_pingpong($("#pvw_self"), "loopback",
                               "vxinternal://preview.img", {delay:250,fill:true});
    };

    mydevice.set_defaults = function(opt) {
    };

    mydevice.get_av_groups = function(opt, cb) {
      let groups = {video:[],audio:[]};
      groups.video.push("Cameras");
      //groups.video.push("-none-");
      cb(groups);
    };
    mydevice.get_av_sources = function(kind,name,cb) {
      if (name == "Cameras") {
        cb([{i:1,n:"Front Camera"},{i:2,n:"Back Camera"}]);
      } else {
        cb([{i:0,n:"-none-"}]);
      }
    };

    mydevice.start_capture = function(opt) {
      let back = false;
      let none = false;
      let cmds = opt.cmds.slice();

      switch(opt.sel_video) {
      case 1:
        mydevice.vt = {sm:true, lg:true};
        break;
      case 2:
        back = true;
        mydevice.vt = {sm:true, lg:true};
        break;
      default:
        none = true;
        mydevice.vt = {};
        break;
      }

      if (opt.skipth) {
        cmds.push("gop_skip_threshold="+opt.skipth);
      } else {
        cmds.push("gop_skip_threshold=0.4");
      }
      if (opt.upload && opt.upload.curl) {
        opt.upload.sockopts = opt.upload.curl;
      }

      //opt.cmds.push("aenc_reset_interval=120");
      window.capbrPost("start", {
        cmds: opt.cmds,
        fmt: opt.fmt,
        upload: opt.upload,
        preview : { "width":640, "height":360, fps:4 },
        video: {
          back: back,
          none: none,
          cam_fps: 18,
          /* FIXME. Should exactly match largest tile */
          cam_width: 656,
          cam_height: 368,
          srate: 44100,
          stbl: "off",
          scaler: "sws",
          scalerAlgo: opt.is_pres ? "FAST_BILINEAR" : "BICUBIC",
          threads: 2,
          me: "hex",
          merange: 16,
          subme: 4
        },
        cb: "gbl_session_callback($ARGS)"
      });
    };

    mydevice.stop_capture = function(opt,cb) {
      delete mydevice.vt;
      window.capbrPost("stop", {});
      if (cb) { cb(null,{}); }
    };

    mydevice.start_preview = function(opt,cb) {
      if (cb) { cb(null,{}); }
    };

    mydevice.flip_camera = function(opt,cb) {
      capbrPost("swcam", {});
    };

    mydevice.tupload_restart = function() {
      capbrPost("restart_upload", {});
    };

    mydevice.tupload_stall = function(dur) {
      capbrPost("stall_upload", {"dur" : dur });
    };

    mydevice.open_native_url = function(url, in_webview=true) {
      let opt = { url : url };
      if (in_webview) {
        opt.back_url = window.location.href;
      }
      window.capbrPost("open_url", opt);
    };

    mydevice.get_audio_gain = function() {
      return mydevice.audio_gain;
    }
    mydevice.set_audio_gain = function(g) {
      mydevice.audio_gain = g;
    }

    mydevice.bridge_kind = "and";
    mydevice.audio_gain = 2;
    mydevice.set_background = false;
    mydevice.capture_state = "unknown";
    mydevice.can_capture = true;
    mydevice.has_bridge = true;
    mydevice.has_preview = false;
    mydevice.do_jackunplug = false;
    mydevice.can_flip = true;
    mydevice.show_refresh = false;
    mydevice.always_has_lg = true;
    window.vx.localloopback = {active:false};
    window.vx.about.app_kind = "android";
    mydevice.is_app = true;
    window.vx.about.is_app = true;
    window.capbrPost("attach", { cb: "gbl_session_callback($ARGS)" });
    mydevice.ss_local = true;
    mydevice.multi_window = false;
    mydevice.pt_can_play = 2;
    mydevice.pt_can_send = false;
    mydevice.tracking_setting = "none";

  } else {
    /* DEVICE: Browser */
    const localMedia = new MediaDevices();
    const mirrorMedia = new MediaDevices();
    const aaRec = {};
    const shim = {};
    let   msgmap = {};
    let   msgid = 1;
    let   audioUploadWorker;
    let   videoUploadWorker;
    let   cur_audio_activity = 0;

    mydevice.can_useWPlay = true;
    mydevice.capture_state = "off";
    mydevice.set_background = true;
    mydevice.can_capture = true;
    mydevice.otf_src_change = true;
    mydevice.release_on_hide = false;
    mydevice.has_bridge = false;
    mydevice.has_preview = false;
    mydevice.can_flip = false;
    mydevice.show_refresh = true;
    mydevice.has_open_dup = true;
    mydevice.always_has_lg = false;
    mydevice.is_capturing = false;
    mydevice.vcapturing = false;
    mydevice.is_ios_browser =
      (/iPad|iPhone|iPod/.test(navigator.platform) ||
       (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1));
    mydevice.is_iphone_browser =
      (/iPhone/.test(navigator.platform));
    mydevice.is_ipad_browser =
      (/iPad/.test(navigator.platform));
    mydevice.pt_can_send = true;
    mydevice.has_audio_selection = true;
    mydevice.audcap = 'worklet';
    if (/(Mac)/i.test(navigator.platform)) {
      /* Mac supports worklet but performs better with script */
      mydevice.audcap = 'script';
    }
    if (window.navigator.standalone ||
        window.matchMedia('(display-mode: standalone)').matches) {
      mydevice.is_pwa = true;
      if (vx && vx.debug) { console.log("Is PWA"); }
    }
    if (!window.vx.about.is_chrome) {
      mydevice.skipDisplayVideo = true;
      mydevice.skipDisplayAudio = true;
    }

    if (!navigator.mediaDevices) {
      let fn = function() {
        console.warn("navigator.mediaDevices: disallowed");
      }
      let pfn = function() {
        console.warn("navigator.mediaDevices: disallowed");
        return new Promise((resolve,reject) => {
          reject("navigator.mediaDevices: disallowed");
        });
      }
      navigator.mediaDevices = {};
      navigator.mediaDevices.removeEventListener = fn;
      navigator.mediaDevices.addEventListener = fn;
      navigator.mediaDevices.getDisplayMedia = pfn;
      navigator.mediaDevices.getUserMedia = pfn;
    }
    if (!crypto.randomUUID) {
      crypto.randomUUID = function() {
        return ("uuid-"+Math.random().toString(36).substring(2,15)+
                "-"+Date.now());
      }
    }

    window.vx.localloopback = {active:false};
    mydevice.is_app = false;
    window.vx.about.is_app = false;
    window.vx.about.os_version = nav_pl;
    window.vx.about.app_uuid = crypto.randomUUID();

    /* It's not useful to open multiple windows on mobile.
     *  since only one at a time can be seen */
    if (mydevice.is_ios_browser ||
        /Mobi/i.test(window.navigator.userAgent)) {
      mydevice.is_mobile = true;
      mydevice.multi_window = false;
      localMedia.max_rtc_fps = 12;
    }

    //window.addEventListener("message", (event) => {
    //  if (event.source != window.parent) { return; }
    //  console.log("MSG",event.data);
    //  window.parent.postMessage("hello","*");
    //}, false);
    vxslog({p:"-",a:"loading"});

    /*
    mydevice.resizeObserver = new ResizeObserver(entries => {
      let w = entries[0].target.scrollWidth;
      let h = entries[0].target.scrollHeight;
      if (!w || !h) { return; }
      event_to_parent({
        type:"resize",
        width:w,
        height:h,
      });
    });
    mydevice.resizeObserver.observe(document.body);
    */

    if (window.vx.about.is_opera) {
      window.vx.about.os_version += "_Opera";
    } else if (mydevice.is_ios_browser) {
      window.vx.about.os_version += "_iOS";
      mydevice.help_allowcam = "https://videocafe.live/camera-microphone-permissions.html#iOS";
    } else if (window.vx.about.is_safari) {
      window.vx.about.os_version += "_Safari";
      mydevice.help_allowcam = "https://videocafe.live/camera-microphone-permissions.html#Safari";
    } else if (window.vx.about.is_edge) {
      window.vx.about.os_version += "_Edge";
      mydevice.has_huge = true;
    } else if (window.vx.about.is_firefox) {
      window.vx.about.os_version += "_Firefox";
    } else if (window.vx.about.is_chrome) {
      window.vx.about.os_version += "_Chrome";
      mydevice.has_huge = true;
      if (mydevice.is_mobile) {
        mydevice.help_allowcam = "https://videocafe.live/camera-microphone-permissions.html#Android";
      } else {
        mydevice.help_allowcam = "https://videocafe.live/camera-microphone-permissions.html#Chrome";
      }
    }
    if (mydevice.is_mobile) {
      window.vx.about.os_version += "_mobile";
    }
    set_post_login_url(window.location.href, Date.now());
    mydevice.tracking_setting = "none";
    mydevice.audio_gain = 1;

    /* If MSE unsupported use JS version */
    if (getLocal("_forcejsmse")) {
      window.MediaSource = null;
      console.warn("FORCING JSMSE");
    }
    if (window.MediaSource) {
      mydevice.has_mse = true;
      mydevice.pt_can_play = 4;
    } else {
      mydevice.has_mse = false;
      window.jsMSE = jsMSE;
      window.MediaSource = jsMSE;
      mydevice.pt_can_play = 1;
    }

    /* This strange test is to catch both iPad's listed as iPad as well
       as iPads showing up as MacIntel+mobile while skipping explicit
       iPhones */
    if ((mydevice.is_ios_browser && !mydevice.is_iphone_browser) &&
        window.MediaSource.name == "jsMSE") {
      if (window.location && !window.location.search.match(/rlded/)) {
        let uri = "//"+window.location.host+window.location.pathname+"?rlded"+window.location.hash;
        window.stop();
        window.location.href = uri;
      } else {
        window.vx.about.app_version = "reloaded";
      }
    }

    if (window.vx.about.is_safari && !mydevice.is_ios_browser) {
      localMedia.loopback_refresh = 2000;
      mirrorMedia.loopback_refresh = 2000;
      localMedia.baseConstraint = {
        aspectRatio: { ideal: 1.77777777778 },
        frameRate: 12
      };
      localMedia.special = localMedia.special || {};
      localMedia.special.safari_visible_canvas = true;
      if (navigator.appVersion) {
        let parts = (navigator.appVersion).match(/Version\/(\d+).(\d+).?(\d+)?/);
        let safVer = parts && parts[1] && parseInt(parts[1], 10);
        if (safVer >= 16) {
          delete localMedia.loopback_refresh;
          delete mirrorMedia.loopback_refresh;
          localMedia.special.safari16_aspect_ratio_fix = true;
        }
      }
    }

    /* iOS has many restrictions about getUserMedia calls and
     *   requires special actions to handle rotation */
    if (mydevice.is_ios_browser) {
      if (!mydevice.has_mse) {
        /* Turn on no-sleep-video */
        localMedia.NSV_update({enable:true});
      }
      mydevice.enable_debug_graph = false;
      mydevice.ao_keep_loopback = true;
      mydevice.do_jackunplug = true;
      mydevice.audio_gain = 2;
      localMedia.unsafeRefresh = true;
      mirrorMedia.unsafeRefresh = true;
      localMedia.baseConstraint = {
        aspectRatio: { ideal: 1.77777777778 },
        frameRate: 12
      };
      localMedia.special = localMedia.special || {};
      localMedia.special.safari_visible_canvas = true;
      if (navigator.appVersion) {
        /* OS X 10_15_6 -or-  OS 15_1 -or- OS 16_4_1
         *  iPad in desktop mode comes up as "OS X 10_15_6" making
         *  the OS version somewhat useless. Since iOS 16+
         *  is the most likely just apply the following fixes universally
         *  for iOS. */
        //let parts = (navigator.appVersion).match(/OS X?\s?(\d+)_(\d+)_?(\d+)?/);
        //let ver;
        //if (parts && parts[1]) {
        //  ver = parseInt(parts[1], 10);
        //}
        // if (ver >= 15) {
        mydevice.audio_gain = 15;
        // if (safVer >= 16) {
        localMedia.special.ios16_portrait_fix = true;
      }
      mydevice.compute_orientation = function(vt) {
        if (!vt || !mydevice.orien) { return; }
        let or = vt.or;
        vt.or = mydevice.orien[""+window.orientation];
        if (!or || or == vt.or) {
          return;
        }
        //No longer necessary if processed through a canvas
        //window.update_user_assets();
      };
      window.addEventListener("orientationchange", function(e) {
        mydevice.compute_orientation(mydevice.vt);
      });
      document.addEventListener("visibilitychange", function() {
        /* iPhone + streaming + hidden, e.g. phone call or minimize
         *  breaks websockets and media until reloaded */
        if (mydevice.capture_state != "off") {
          mydevice.stop_capture();
        } else if (!document.hidden) {
          //window.location.reload();
          delete vx.wss;
          delete vx.wss_refresh_at;
          clearTimeout(vx.wss_tid);
          wss_open(vx, {});
        }
      });
    } else {
      mydevice.compute_orientation = function(vt) { };
      if (mydevice.is_mobile) {
        /* Primarily Android */
        //localMedia.unsafeRefresh = true;
        //mirrorMedia.unsafeRefresh = true;
        document.addEventListener("visibilitychange", function() {
          if (mydevice.capture_state == "off" ||
              !document.hidden) {
            return;
          }
          mydevice.stop_capture();
        });
      }
    }
    if (mydevice.in_iframe) {
      localMedia.unsafeRefresh = true;
      mirrorMedia.unsafeRefresh = true;
    }

    setInterval(function() {
      /* Monitors global capture status across any
         open windows */
      if (vx_vid_valid()) {
        mydevice.is_capturing = true;
        $(".capturestate").attr("cap","rec");
      } else {
        mydevice.is_capturing = false;
        $(".capturestate").attr("cap","off");
      }
    }, 1000);

    mydevice.get_audio_gain = function() {
      return mydevice.audio_gain;
    }
    mydevice.set_audio_gain = function(g) {
      mydevice.audio_gain = g;
    }
    mydevice.get_media = function() {
      return localMedia;
    }

    mydevice.get_av_groups = function(opt, cb) {
      let gopt = {};
      gopt.skipDisplayVideo = mydevice.skipDisplayVideo;
      gopt.skipDisplayAudio = mydevice.skipDisplayAudio;
      gopt.enumerate_video = opt.enumerate_video;
      gopt.enumerate_audio = opt.enumerate_audio;
      localMedia.getGroups(gopt,cb);
    }
    mydevice.get_av_sources = function(kind, name, cb) {
      localMedia.getSources(kind,name,cb);
    }

    window.stop_localloopback = function() {
      localMedia.inwall = false;
      /* Don't trigger hide if capture panel is open as it might
       *  hide the preview. */
      if (!localMedia.cpanel) {
        localMedia.hideVideo();
      }
    }

    window.start_localloopback = function($el) {
      localMedia.inwall = true;
      localMedia.showVideo($el[0],{"max-height":"100%"});
    }

    window.NSV_update = function(opt) {
      opt = opt || {};
      if (opt.cpanel === true) {
        localMedia.cpanel = true;
      } else if (opt.cpanel == false) {
        localMedia.cpanel = false;
      }
      localMedia.NSV_update(opt);
      if (!localMedia.inwall) {
        /* If not in the wall, it might be on the capture panel
         *  preview. Move it to body. */
        localMedia.hideVideo();
      }
    }

    mydevice.handle_shim_msg = function(msg, name, uworker) {
      if (msg._cmd == "create") {
        if (vx && vx.debug) { console.log("shim: create",name); }
        let w = new EncodeWorker();
        w.onmessage = function(e) {
          let nocopy = [];
          e.data._type = "shim";
          e.data._name = name;
          if (e.data.buf) { nocopy.push(e.data.buf); }
          //console.log(JSON.stringify(e.data),JSON.stringify(nocopy));
          uworker.postMessage(e.data, nocopy);
        };
        shim[name] = w;
      } else if (msg._cmd == "pm") {
        let nocopy = [];
        if (msg.arr) { nocopy.push(msg.arr); }
        if (msg.y) { nocopy.push(msg.y); }
        if (msg.u) { nocopy.push(msg.u); }
        if (msg.v) { nocopy.push(msg.v); }
        //console.log(JSON.stringify(msg),JSON.stringify(nocopy));
        shim[name].postMessage(msg, nocopy);
      } else if (msg._cmd == "terminate") {
        if (vx && vx.debug) { console.log("shim: terminate",name); }
        shim[name].terminate();
        delete shim[name];
      }
    }

    mydevice.upload_messages = function(e) {
      let msg = e.data;
      if (msg["type"] == "ready") {
        let opt = {};
        if (vx && vx.debug) { console.log("Uploader signaled ready:",msg.start_ep); }
        opt.start_ep = msg.start_ep;
        opt.srvr_start_ep = msg.srvr_start_ep;
        if (videoUploadWorker) {
          /* Video waits until audio has set 'ep' to open */
          videoUploadWorker.postMessage({type:"open",
                                         start_ep: msg.srvr_start_ep});
        }
        localMedia && localMedia.enableCaptureOutput(opt);
      } else if (msg["type"] == "vtick") {
        localMedia && localMedia.vtick();
      } else if(msg["type"] == "activity") {
        cur_audio_activity = 0|msg["max"];
      } else if (msg["type"] == "stopped") {
        if (vx && vx.debug) { console.log("Uploader signaled stop"); }
        if (msg.error) {
          console.warn("Unable to connect to server", msg.error);
          window.show_notification("Unable to connect to server.","danger", 20);
        }
        mydevice.stop_capture();
      } else if (msg["type"] == "capturing") {
        /* A heartbeat */
        vx_vid_heartbeat();
      } else if (msg.type == "audiorate") {
        if (mydevice.only_show_self) { return; }
        let d = localMedia.degraded;
        if (!d.init) {
          d.init = true;
          d.elp = 0;
          d.standoff = 10000;
          d.low = 0;
          d.max_low = 0;
          if (__vue && __vue.$children[0]) {
            __vue.$children[0].tmp_cur_low = 0;
            __vue.$children[0].tmp_max_low = 0;
          }
        }
        d.standoff -= msg.ms;
        d.elp += msg.ms;
        if (d.standoff > 0) {
          /* Wait to stablize */
          //console.log("arate: initial wait:"+d.standoff);
          return;
        }

        if (msg.fps > 45) {
          //console.log("arate: high:"+Math.trunc(msg.fps)+","+d.low);
        } else if (msg.fps > 41) {
          //console.log("arate: ok  :"+Math.trunc(msg.fps)+","+d.low);
          if (d.low > msg.ms) {
            d.low -= msg.ms; //1
          } else {
            d.low = 0;
          }
        } else if (msg.fps <= 34) {
          //console.log("arate: low :"+Math.trunc(msg.fps)+","+d.low);
          d.low += 1.5*msg.ms; //3
        } else if (msg.fps <= 37) {
          //console.log("arate: low :"+Math.trunc(msg.fps)+","+d.low);
          d.low += 1.2*msg.ms; //2
        } else if (msg.fps <= 40) {
          //console.log("arate: low :"+Math.trunc(msg.fps)+","+d.low);
          d.low += msg.ms; //1
        }
        if (!d.max_low || d.low > d.max_low) {
          d.max_low = d.low;
        }
        if (__vue && __vue.$children[0]) {
          __vue.$children[0].tmp_cur_low = (d.low/1000).toFixed(1);
          __vue.$children[0].tmp_max_low = (d.max_low/1000).toFixed(1);
        }
        if (localMedia.prtc &&
            (mydevice.testkill == 1 || d.low >= 15000)) {
          if (vx && vx.debug) { console.warn("KILL RTC"); }
          delete mydevice.testkill;
          delete mydevice.vt.pt;
          window.update_user_assets();
          localMedia.prtc._wss.close();
          localMedia.prtc.close();
          delete localMedia.prtc;
          mydevice.stop_share({}, function() {});
          delete d.init;
        } else if (localMedia.recordVideo &&
                   (mydevice.testkill == 2 || d.low >= 15000)) {
          if (vx && vx.debug) { console.warn("DISABLE VIDEO"); }
          delete mydevice.testkill;
          delete mydevice.vt.pt;
          delete mydevice.vt.sm;
          window.update_user_assets();
          /* Return video to disabled state similar to
           *   when started as audio-only */
          mydevice.vcapturing = false;
          localMedia.streamVideoCapture({
            mode:{sm:false, pt:false},
          }, null, function(status,vt) {
          });
          if (__vue && __vue.$children[0]) {
            __vue.$children[0].video_off = true;
          }
          delete d.init;
        }
      } else if (msg._type == "shim") {
        mydevice.handle_shim_msg(msg, msg._name, audioUploadWorker);
      } else {
        console.warn("Uploader: unexpected",JSON.stringify(e.data));
      }
    }

    mydevice.uploadv_messages = function(e) {
      let msg = e.data;
      if (msg["type"] == "capturing") {
        /* A heartbeat */
        if (false && msg.fps_avg) {
          let sm = {};
          if (!mydevice.esm) {
            mydevice.esm = [ ];
            mydevice.esm_cnt=0;
            mydevice.fps_low = 0;
          }
          sm.fps_avg = msg.fps_avg;
          sm.fps_min = msg.fps_min;
          sm.edrop = msg.edrop;
          mydevice.esm_cnt++;
          mydevice.esm.push(sm);
          let len = mydevice.esm.length;          
          if (len > 10) {
            mydevice.esm.shift();
            len = 10;
          }
          let s1=0,s2=0,s3=0;
          mydevice.esm.forEach(function(x) {
            s1 += x.fps_avg|0;
            s2 += x.fps_min|0;
            s3 += x.edrop|0
          });
          mydevice.fps_avg = Math.round(10*s1 / len)/10;
          mydevice.fps_min = Math.round(10*s2 / len)/10;
          mydevice.edrop = s3;
          if ((mydevice.esm_cnt >= 12 && mydevice.fps_avg < 20 && mydevice.edrop > 1) ||
              (mydevice.edrop > 10)) {            
            if (++mydevice.fps_low == 3) {
              if (mydevice.vt.lg) {
                window.show_notification("Your system is not generating video fast enough and would do better in a lower performance mode. Please stop and restart for this setting to take effect.","warning",8);
                window.setLocal("vx_video_max","1");
              } else {
                /* Small not ok. Audio only? */
              }
            }
          } else {
            mydevice.fps_low = 0;
          }
        }
      } else if (msg["type"] == "stopped") {
        if (vx && vx.debug) { console.log("UploaderV signaled stop"); }
      } else if (msg._type == "shim") {
        mydevice.handle_shim_msg(msg, msg._name, videoUploadWorker);
      } else {
        console.warn("UploaderV: unexpected",JSON.stringify(e.data));
      }
    }

    /*
    mydevice.savePCMFile = function() {
       var data = new Blob([mydevice.allpcm], {type: 'octet/stream'});
      let pcmFile = window.URL.createObjectURL(data);
      let link = document.getElementById('downloadlink');
      link.href = pcmFile;
      link.style.display = 'block';
      link.download = "audio.pcm";
    }
    */
    mydevice.msg_opener = function(msg,cb) {
      if (!window.opener) { console.log("no opener"); return; }
      msg._id = ++msgid;
      msg._rq = true;
      msg._room = vx && vx.room && vx.room.name;
      if (cb) {
        if (Object.keys(msgmap).length > 50) {
          console.warn("msgmap too large");
          msgmap = {};
        }
        msgmap[msg._id] = cb;
      }
      window.opener.postMessage(msg);
    };

    window.addEventListener("message", (event) => {
      if (event.origin != ("https://"+window.location.host)) {
        return;
      }
      let j = event.data;
      if (j._id && j._rq) {
        let rsp = {};
        rsp._rsp = true;
        rsp._id = j._id;
        rsp.target = j.target;
        if (j._room) {
          if (!vx || !vx.room || vx.room.main_room != j._room) {
             rsp.error = "wrong room";
             event.source.postMessage(rsp);
             return;
          }
        }
        rsp._room = vx.room.name;
        rsp._main_room = vx.room.main_room;
        if (j.target == "mirror") {
          if (j.cmd == "start") {
            mydevice.start_mirror(j.opt,function(err,msg) {
              if (msg) {
                rsp.rsp = "started";
                rsp.state = "active";
                wss_send(vx, "msg_to", {msg:"$alertThis meeting is being recorded.", to:{room:true}, eph:true});
              } else {
                rsp.rsp = "error";
                rsp.error = err;
                rsp.state = "off";
              }
              event.source.postMessage(rsp);
            });
          } else if (j.cmd == "stop") {
            mydevice.stop_mirror(j.opt,function() {
              rsp.rsp = "mirror stopped";
              rsp.state = "off";
              event.source.postMessage(rsp);
            });
          } else if (j.cmd == "state") {
            rsp.state = mirrorMedia.rtcState();
            rsp.status = mirrorMedia.mirrorStatus();
            event.source.postMessage(rsp);
          } else if (j.cmd == "addRTMP") {
            mirrorMedia.addRTMP(j.opt,function(err) {
              if (err) {
                rsp.rsp = err;
              } else {
                rsp.rsp = "added";
              }
              event.source.postMessage(rsp);
            });
          } else if (j.cmd == "stopRTMP") {
            mirrorMedia.stopRTMP(j.opt,function(err) {
              if (err) {
                rsp.rsp = err;
              } else {
                rsp.rsp = "stopped";
              }
              event.source.postMessage(rsp);
            });
          } else if (j.cmd == "metaseg") {
            mirrorMedia.sendCMD(j.cmd,j.opt.txt,function(err) {
              if (err) {
                rsp.rsp = err;
              } else {
                rsp.rsp = "sent";
              }
              event.source.postMessage(rsp);
            });
          } else if (j.cmd == "navbar") {
            if (j.opt.vis) {
              $(".navbar").attr("hide","false");
            } else {
              $(".navbar").attr("hide","true");
            }
            event.source.postMessage(rsp);
          } else {
            console.warn("Unknown command",j.cmd);
          }
        } else if (j.target == "wss") {
          wss_send(vx, j.cmd, j.opt);
        } else {
          rsp.error = "unknown";
          event.source.postMessage(rsp);
        }
      } else if (j._id && j._rsp) {
        if (msgmap[j._id]) {
          msgmap[j._id](j);
          delete msgmap[j._id];
        }
      }
    }, false);

    if (!mydevice.in_iframe) {
      mydevice.start_mirror = function(opt,cb) {
        if (!vx.user || !vx.user.id || !vx.user.creds["rtmp"]) { return; }
        if (!vx.indomain) { return; }
        if (aaRec.wss) {
          cb && cb("audio recording in progress");
          return;
        }
        let config = {};
        let aid = parseInt("0x"+vx.user.id.substr(-13));
        config.handle = opt.handle;
        config.post_url = "https://"+vx.indomain+"/";
        config.httphdrs = {"vx-assetid":aid,
                           "vxmob-info":"mirror"+(vx.room && vx.room.name),
                           "vx-mode":"flv_rtmp",
                           "vx-rqidx":"2",
                           "vxmob-hburl":vx.user.creds["rtmp"],
                           "vx-s":Math.random().toString(36).substring(2,15)};
        mirrorMedia.startMirror(config, function(r) {
          if (r) {
            if (__vue && __vue.$children[0]) {
              __vue.$children[0].disable_notifications = true;
            }
            cb && cb(null,"ok");
          } else {
            cb && cb();
          }
        });
      }
    }//!in_iframe

    mydevice.set_audio_at = function(at) {
      mirrorMedia.set_audio_at(at);
    }

    mydevice.mirror_state = function() {
      return mirrorMedia.rtcState();
    }

    mydevice.stop_mirror = function(opt,cb) {
      if (__vue && __vue.$children[0]) {
        __vue.$children[0].disable_notifications = false;
      }
      mirrorMedia.stopCapture();
      cb && cb();
    }

    mydevice.aarec_get_status = function() {
      //console.log(aaRec.s, mirrorMedia.rtcState());
      if (!aaRec.s || !aaRec.s.status || aaRec.s.status == "off") {
        if (mirrorMedia.rtcState() != "off") {
          return {status:"disabled"};
        }
      }
      return aaRec.s || {status:"off"};
    }

    mydevice.aarec_start = function(opt,status_cb) {
      status_cb = status_cb || function(){};
      if (!vx.user || !vx.user.id || !vx.user.creds["rtmp"]) { return; }
      if (!vx.indomain || !vx.room || !vx.room.name) { return; }
      if (aaRec.wss) {
        status_cb({error:"Already recording"});
        return;
      }
      if (mirrorMedia.rtcState() != "off") {
        status_cb({error:"Mirroring in progress"});
        return;
      }
      let config = {};
      let aid = parseInt("0x"+vx.user.id.substr(-13));
      let hdrs = {"vx-assetid":aid,
                  "vxmob-info":"mirror"+vx.room.name,
                  "vx-mode":"aa_arc",
                  "vx-rqidx":"2",
                  "vxmob-hburl":vx.user.creds["rtmp"],
                  "vx-s":Math.random().toString(36).substring(2,15)};
      let url = "wss://"+vx.indomain+":8083/rtc";
      aaRec.s = {status:"pending", elapsed:0, room:vx.room.name};
      aaRec.wss = new WebSocket(url);
      aaRec.status_cb = status_cb;
      aaRec.status_cb(aaRec.s);
      aaRec.wss.onopen = function() {
        if (vx && vx.debug) { console.log("aa wss opened",url); }
        let cmd = "start\n";
        /* Required AND must be first */
        cmd += "vx-mode="+hdrs["vx-mode"]+"\n";
        Object.keys(hdrs).forEach(function(h) {
          if (h == "vx-mode") { return; }
          cmd += ""+h+"="+hdrs[h]+"\n";
        });
        if (vx && vx.debug) { console.log("aa wss cmd",cmd); }
        aaRec.wss.send(cmd);
        window.buildSearchURL(window.vx, function(surl) {
          let handle = opt.handle;
          aaRec.wss.send(`config searchurl,${handle},${surl}`);
          aaRec.wss.send("config startarc");
          aaRec.s.status = "rec";
          aaRec.status_cb(aaRec.s);
        });
        wss_send(vx, "msg_to", {msg:"$alertThis meeting is being recorded.", to:{room:true}, eph:true});
        /* For keep-alive and to get status*/
        aaRec.wss._ping_tid = setInterval(function() {
          aaRec.wss.send("config status");
        }, 5000);
      };
      aaRec.wss.onmessage = function(msg) {
        let j = to_json(msg.data);
        if (j && j.kind == "status") {
          aaRec.s.elapsed = j.elapsed/1000;
          aaRec.status_cb(aaRec.s);
        } else {
          if (vx && vx.debug) { console.log("aa wss msg",msg); }
        }
      };
      aaRec.wss.onclose = function() {
        mydevice.aarec_stop();
      }
      aaRec.wss.onerror = function() {
        aaRec.wss && clearTimeout(aaRec.wss._ping_tid);
      }
    }

    mydevice.aarec_stop = function() {
      if (aaRec.wss) {
        aaRec.wss.close();
        clearTimeout(aaRec.wss._ping_tid);
        delete aaRec.wss;
      }
      aaRec.s.status = "off";
      if (aaRec.status_cb) {
        aaRec.status_cb(aaRec.s);
        delete aaRec.status_cb;
      }
    }

    mydevice.update_vt = function(vt,ss) {
      //console.log("update_vt",JSON.stringify(vt));
      if (window.vx.user && ss) {
        window.vx.user.ss = ss;
      }
      if (!mydevice.vt) { return; }
      let has_video = false;
      delete mydevice.vt.sm;
      delete mydevice.vt.pt;
      if (vt) {
        if (vt.sm) {
          mydevice.vt.sm = true;
          has_video = true;
        }
        if (vt.pt) {
          mydevice.vt.pt = true;
          has_video = true;
          mydevice.compute_orientation(mydevice.vt);
        }
      }
      if (__vue.$children[0] && __vue.$children[0].showCamBtn) {
        __vue.$children[0].showCamBtn(true,!has_video);
      }
      localMedia && localMedia.getOrientationCorrection(mydevice);
      window.update_user_assets();
    }

    mydevice.transcribe_start = function(cb) {
      awsTranscriber.open({},cb);
    }

    mydevice.transcribe_stop = function() {
      awsTranscriber.close();
    }

    mydevice.start_capture = function(opt) {
      console.log("Start Capture");
      if (!localMedia.inwall) {
        localMedia.hideVideo();
      }
      localMedia.degraded = {};

      if (audioUploadWorker) {
        audioUploadWorker.terminate();
        audioUploadWorker = null;
      }
      if (videoUploadWorker) {
        videoUploadWorker.terminate();
        videoUploadWorker = null;
      }

      let vfmts=[];
      opt.fmt.scfg.forEach(function(f) {
        if (f.t.charAt(0) != "t") { return; }
        let wh = f.t.replace(/[ts]+/g,"").split("x");
        if (vfmts.length < 2) {
          let vfmt = {};
          vfmt.w = (0 | wh[0]);
          vfmt.h = (0 | wh[1]);
          vfmt.t = f.t;
          vfmt.crf = f.crf;
          vfmt.maxrate = f.maxrate;
          vfmt.bufsize = f.bufsize;
          vfmt.fps = opt.fmt.fps;
          vfmt.fpg = opt.fmt.fpg;
          vfmt.bfrm = opt.fmt.bfrm;
          if (opt.video_lg) {
            vfmts.push(vfmt);
          } else {
            vfmts[0] = vfmt;
          }
        }
      });
      //vfmts[0].w = 656;
      //vfmts[0].h = 368;
      //vfmts[0].t = "t656x368";

      let startAudio = function() {
        let lmopt = {};
        if (vx && vx.debug) { console.log("startAudio"); }
        mydevice.is_capturing = true;
        lmopt.gid = opt.sel_audio;
        lmopt.ucfg = opt.upload;
        if (false/*Force Follow Hint*/) {
          console.warn("Forcing audcap",opt.audcap);
          lmopt.audcap = opt.audcap;
        } else {
          lmopt.audcap = mydevice.audcap;
        }
        lmopt.cb_pushraw = function(fct, sr, ch, lbuf, rbuf) {
          if (!audioUploadWorker) { return; }
          let transfer = [];
          lbuf && transfer.push(lbuf);
          rbuf && transfer.push(rbuf);

          awsTranscriber.set_sample_rate(sr);
          if (lbuf) {
            awsTranscriber.sendFLT(lbuf);
          }

          if (!lbuf && !rbuf) {
            mydevice.zeros++;
            if (mydevice.zeros > 10 &&
                !mydevice.zero_muted) {
              mydevice.zero_muted = true;
              if (window.updateUserState) {
                window.updateUserState(window.vx.room, "blk", 1, true);
              }
            }
          } else {
            mydevice.zero_muted = false;
            mydevice.zeros = 0;
          }
          audioUploadWorker.postMessage({type:"raw",
                                         fct: fct,
                                         sr: sr,
                                         ch: ch,
                                         lbuf: lbuf,
                                         rbuf: rbuf,
                                        }, transfer);
        }
        localMedia.streamAudio(lmopt, function(ctx,err) {
          if (vx && vx.debug) { console.log("streamAudio callback"); }
          if (!ctx) {
            let msg = err ? err.error : "Failed to access audio device.";
            console.warn(msg);
            opt.notify && opt.notify('err',msg);
            mydevice.stop_capture();
            return;
          }
          audioUploadWorker = new UploadAWorker();
          audioUploadWorker.onmessage = mydevice.upload_messages;
          audioUploadWorker.postMessage({type:"init",
                                         ucfg:opt.upload,
                                         ecfg:opt.fmt,
                                         debug:vx && vx.debug});
          window.vx.localloopback.active = true;
          mydevice.capture_state = "capturing";
        });
        vxslog({p:"cap",a:"audio",g:lmopt.gid});
      } // startAudio

      if (vfmts.length && opt.sel_audio) {
        let lmopt = {}
        // Also set in startAudio
        mydevice.is_capturing = true;
        mydevice.vt = {};

        lmopt.gid = opt.sel_video;
        if (lmopt.gid) {
          if (opt.video_pt) {
            lmopt.rtc = true;
            lmopt.mode = {sm:true, pt:true};
          } else {
            lmopt.rtc = false;
            lmopt.mode = {sm:true, pt:false};
          }
          mydevice.vcapturing = true;
          vxslog({p:"cap",a:"video",g:lmopt.gid});
        } else {
          lmopt.mode = {sm:false, pt:false};
        }
        lmopt.agid = opt.sel_audio;
        lmopt.fmts = vfmts;
        lmopt.fct = opt.video_fct;
        lmopt.ucfg = opt.upload;
        lmopt.bg_ef = mydevice.bgef;
        lmopt.cb_pushraw = function(fct,rgba) {
          if (!videoUploadWorker) { return; }
          videoUploadWorker.postMessage({type:"raw",
                                         fct: fct,
                                         rgba: rgba
                                        },
                                        [ rgba ]);
          return;
        }

        localMedia.streamVideo(lmopt, function(status,vt) {
          if (status == "error") {
            console.warn("Failed at streamVideo");
            opt.notify && opt.notify(8, "Failed to access video device.");
            mydevice.stop_capture();
            return;
          }
          mydevice.update_vt(vt);
          if (opt.video_sm) {
            videoUploadWorker = new UploadVWorker();
            videoUploadWorker.onmessage = mydevice.uploadv_messages;
            videoUploadWorker.postMessage({type:"init",
                                           ucfg:opt.upload,
                                           ecfg:vfmts,
                                           debug:vx && vx.debug});
          }
          startAudio();
        }, function(ev) {
          if (!ev || ev.type == "ended") {
            /* Primary video track went away. */
            mydevice.stop_capture();
          } else if (ev.type == "rtcfailed") {
            /* Source is ok but rtc failed */
            delete mydevice.vt.pt;
            if (window.vx.user) { window.vx.user.ss = "-"; }
            window.update_user_assets();
            window.vx_nav_callback("notify",{
              c: 8, m: "We were unable to connect to the server to send hi-res video. Please confirm outbound ports to our server are not blocked."
            });
          }
        });
      } else {
        console.warn("No audio/video selected");
        mydevice.capture_state = "off";
      }
    }

    mydevice.change_spk_src = function(opt,cb) {
      let devid = opt.sel_speaker.split("|")[1];
      if (!devid) { return; }
      let el = document.getElementById("__tmprtcaudio");
      if (!el) { return; }
      if (typeof el["setSinkId"] != "function") { return; }
      el.setSinkId(devid).then(function() {
        cb();
      }).catch(function(err) {
        cb(err);
      });
    }

    mydevice.change_aud_src = function(opt,cb) {
      if (mydevice.is_capturing != true) {
        return;
      }
      let lmopt = {}
      lmopt.gid = opt.sel_audio;
      lmopt.audcap = mydevice.audcap; /* a hint */
      lmopt.sel_idx = opt.sel_idx; /* 0 == primary, 1 = background */
      if (opt.sel_audio != "--noaudio--") {
        localMedia.streamAudio(lmopt, function(ctx,err) {
          console.log("change acb",err);
          if (!ctx && err && err.error) { cb && cb(err.error); }
        });
      } else {
        localMedia.removeAudio(lmopt, function(ctx) {
        });
      }
      vxslog({p:"cap",a:"audio",g:lmopt.gid});
    }
    
    mydevice.change_vid_src = function(opt,cb) {
      if (vx && vx.debug) {
        console.log("change_vid_src:",
                    opt.capturing,
                    mydevice.vcapturing,
                    localMedia.mode);
      }
      if (!opt.capture && !mydevice.vcapturing) {
        let lmopt = {}
        lmopt.gid = opt.sel_video;
        lmopt.mode = {sm:false, pt:false};
        lmopt.bg_ef = mydevice.bgef;
        /* Reinsert loopback into capture panel */
        localMedia.streamVideo(lmopt, function(status) {
          let el = document.getElementById("pvw_top");
          localMedia.getOrientationCorrection(mydevice);
          localMedia.inwall = false;
          localMedia.showVideo(el);
          cb && cb(status);
        });
        return;
      }
      //console.log("change to ",opt);
      let lmopt = {}
      lmopt.gid = opt.sel_video;
      lmopt.bg_ef = mydevice.bgef;
      if (opt.capture && !mydevice.vcapturing) {
        /* Enabling video */
        if (opt.video_pt) {
          lmopt.rtc = true;
          lmopt.mode = {sm:true, pt:true};
        } else {
          lmopt.rtc = false;
          lmopt.mode = {sm:true, pt:false};
        }
      } else {
        /* Changing camera src does not change rtc or mode settings */
      }
      localMedia.streamVideo(lmopt, function(status,vt) {
        if (status == "ok") {
          /* User likely denied permission to new device selection.
             The old one will continue uninterrupted so only adjust
             'vt' if successful */
          mydevice.vcapturing = true;
          mydevice.update_vt(vt);
        }
        cb && cb(status);
      });
      vxslog({p:"cap",a:"video",g:lmopt.gid});
    }

    mydevice.video_stream_enable = function(enable,cb) {
      localMedia.streamVideoEnable(enable, cb);
    }

    mydevice.video_stream_blur = function(enable,cb) {
      console.log("video_stream_blur",enable);
      localMedia.streamVideoBlur(enable, cb);
    }

    mydevice.stop_render = function(opt) {
      opt = opt || {};
      if (mydevice.capture_state != "off")   {
        return;
      }
      if (!mydevice.ao_keep_loopback || !opt.ao) {
        localMedia.stopCapture(function() {
        });
      } else {
        /* Audio Only on iOS does not play any video. Video is
           required to keep it from sleeping. We can use the
           camera loopback for this purpose. */
        localMedia.hideVideo();
      }
    }

    mydevice.set_pt_kbps = function(kbps) {
      if (mydevice.is_capturing != true) {
        return;
      }
      localMedia.PRTC_set_max_kbps(kbps);
    }

    mydevice.stop_capture = function(opt,cb) {
      let was_capturing = mydevice.is_capturing;
      mydevice.is_capturing = false;
      mydevice.vcapturing = false;
      mydevice.stop_share({skipvt:true});
      vx_vid_erase();
      localMedia.stopCapture(function() {
        if (audioUploadWorker) {
          audioUploadWorker.postMessage({type:"stop"});
        }
        if (videoUploadWorker) {
          videoUploadWorker.postMessage({type:"stop"});
        }
        delete mydevice.vt;
        window.vx.localloopback.active = false;
        mydevice.capture_state = "off";
        window.reject_1on1 && window.reject_1on1();
        cb && cb();
      });
      delete mydevice.esm;
      mydevice.fps_avg = 0;
      if (was_capturing) {
        vxslog({p:"cap",a:"stop"});
      }
    };

    mydevice.query_audio_activity = function(cb) {
      cb && cb(cur_audio_activity);
    };

    // /* can_share will be set if PT enabled */
    mydevice.share_state = "off";

    mydevice.start_share = function(opt={},cb) {
      localMedia.streamShare({}, function(err,rv) {
        if (err) {
          mydevice.share_state = "off";
          cb && cb("failed");
          return;
        }
        if (rv.shared_audio) {
          window.setLocal("vx_agroup1","System");
          window.setLocal("vx_asource1","spk|default,System Speaker Audio");
        }
        mydevice.update_vt(rv.vt,rv.ss);
        mydevice.share_state = "sharing";
        cb && cb(null,"ok");
      },function(ev) {
        if (ev.type == "rtcfailed") {
          /* When rtc fails, both share and primary are notified.
           *  To avoid a race on 'vt' updates, leave it to the
           *  primary end handler to do this update */
          mydevice.stop_share({skipvt:true});
        } else {
          mydevice.stop_share();
        }
      });
    };

    mydevice.swap_share = function() {
      localMedia.swapShare(function(err,rv) {
        /* Called if vt / ss change required */
        if (err) {
          return;
        }
        mydevice.update_vt(rv.vt,rv.ss);
      });
    }

    mydevice.stop_share = function(opt={}) {
      localMedia.stopShare(function(err,rv) {
        /* Called if vt / ss change required */
        if (err) {
          return;
        }
        if (!opt.skipvt) {
          mydevice.update_vt(rv.vt,rv.ss);
        }
      });
      window.setLocal("vx_agroup1",null);
      window.setLocal("vx_asource1",null);
      mydevice.annotate_url = null;
      mydevice.share_state = "off";
    };

    mydevice.bgef.msg = "Background Replacement"
    computeConcurrency(function(threads) {
      mydevice.threads = threads;
      window.vx.about.threads = threads;
      if (!mydevice.is_mobile &&
          (window.vx.about.is_chrome ||
           window.vx.about.is_safari) &&
          threads > 5) {
        mydevice.bgef.show = true;
      }
      if (mydevice.bgef.show) {
        let bgef = window.getLocal("vx_bg_ef",true);
        mydevice.bgef.isel = false;
        mydevice.bgef.img = "";
        if (bgef) {
          ["isel","img"].forEach(function(f) {
            if (bgef[f] === undefined) { return; }
            mydevice.bgef[f] = bgef[f];
          });
        }
      }
    });
  }
  
  window.vx_check_stopcapture = function(vdbid) {
    let local_id = window.getLocal("vx_upid",true);
    if (vdbid && local_id && local_id.vdb && vdbid != local_id.vdb) {
      if (local_id.vdb.localeCompare(vdbid) < 0) {
        /* Local capture id is less than (older than) DB, so stop */
        mydevice.stop_capture({}, function() {
        });
        window.vx.localloopback.active = false;
      }
    }
  }
  if (vx) { vx.open_native_url = mydevice.open_native_url; }
  store.set("mydevice", mydevice);

  if (window.vx.about.is_app) {
    /* An App (CEF, iOS, etc.) */
    check_if_signedin("app");
  } else if (window.vx.about.is_chrome) {
    /* Chrome/Chromium */
    check_if_signedin("browser");
  } else {
    /* Not chrome/chromium or app */
    //vx.disable_live = true;
    check_if_signedin("unbrowser");
  }
}
